<div ion-id="modal-container">
  <div class="header">
    <h1 class="u-text-heading-6 text-neutral-darker" ion-id="modal-title">
      {{ context.title | translate: context.params }}
    </h1>
    <button
      ionButton
      appearance="secondary"
      size="xs"
      ion-id="btn-close-confirmation-modal"
      type="button"
      (click)="cancel()"
      [attr.aria-label]="'GENERAL.CLOSE' | translate"
    >
      <ion-icon [icon]="'close'" />
    </button>
  </div>
  <section class="content" ion-id="confirmation-section">
    <p class="font-bold">{{ context.heading | translate: context.params }}</p>
    @if (context.text) {
      <p class="text-neutral-dark">{{ context.text | translate: context.params }}</p>
    }
    @if (getKeyValueList()) {
      <dl class="summary-table margin-top-xxxs">
        @for (item of getKeyValueList(); track item[0]) {
          <dt translate>{{ item[0] }}</dt>
          <dd>{{ item[1] }}</dd>
        }
      </dl>
    }
    @if (context.additionalWarning) {
      <tui-notification size="m" class="margin-top-md" appearance="warning"
        ><div>
          <p class="text-warning u-text-body-s">{{ context.additionalWarning | translate: context.params }}</p>
        </div></tui-notification
      >
    }
    @if (context.confirmationText) {
      <div class="confirmation-checkbox-block margin-top-md flex items-start gap-xs">
        <input
          tuiCheckbox
          type="checkbox"
          size="s"
          [(ngModel)]="confirmed"
          [attr.id]="confirmationCheckboxId"
          [attr.aria-labelledby]="confirmationLabelId"
          [attr.aria-describedby]="confirmationDescriptionId"
        />
        <div class="u-text-body-s">
          <span class="text-neutral-darker" [attr.id]="confirmationLabelId">
            {{ context.confirmationLabel ?? "GENERAL.CONFIRMATION_REQUIRED" | translate: context.params }}
          </span>
          <div class="text-neutral u-text-body-xs" [attr.id]="confirmationDescriptionId">
            {{ context.confirmationText | translate: context.params }}
          </div>
        </div>
      </div>
    }
  </section>
  <div class="buttons">
    @if (context.cancelButton) {
      <button ionButton size="s" appearance="primary" ion-id="confirmation-cancel" (click)="cancel()">
        {{ context.cancelButton | translate }}
      </button>
    }
    <button
      ionButton
      [appearance]="context.confirmationText ? (confirmed ? 'cta' : 'primary') : 'cta'"
      size="s"
      ion-id="confirmation-confirm"
      (click)="confirm()"
      [loading]="(context.isLoading$ | async) ?? false"
      [disabled]="!!context.confirmationText && !confirmed"
    >
      {{ context.confirmButton | translate }}
    </button>
  </div>
</div>
